
// Components/Inventario/InventarioEquipos.tsx
import { useEffect, useMemo, useState, ChangeEvent } from "react";
import DataTable, { TableColumn } from "react-data-table-component";

import {
  Badge,
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";

import {
  BsExclamationTriangle,
  BsBoxSeam,
  BsCpu,
  BsEye,
  BsHddNetwork,
  BsLaptop,
  BsPencilSquare,
  BsPlusCircle,
  BsSearch,
  BsServer,
  BsTrash3,
  BsWifi,
  BsSliders,
  BsArrowCounterclockwise,
  BsDisplay, 
  BsDiagram3,
} from "react-icons/bs";

import InventarioService from "../../../Services/Catalogos/InventarioService";
import { DTOEquipoInventario } from "../../../DTO/Inventario/DTOEquipoInventario";
import { DTOEstadoEquipo, DTOTipoEquipo } from "../../../DTO/Inventario/DTOCatalogosInventario";
import { DTOGestionarEquipo } from "../../../DTO/Inventario/DTOGestionInventario";
import { MsgInformativo } from "../../../Utils/Toast/msgInformativo";
import ControlContrasenasService from '../../../Services/Catalogos/CatSistemas'
import InventarioMonitores from "./InventarioMonitores";
import ReporteDisponibilidadIPs from "./ReporteDisponibilidadIPs";


import FormularioEquipo from "./FormularioEquipo";
import DetalleEquipo from "./DetalleEquipo";

const obtenerMensajeError = (error: unknown): string => {
  const errorAxios = error as {
    response?: { data?: { mensaje?: string } };
    message?: string;
  };
  return errorAxios.response?.data?.mensaje ?? errorAxios.message ?? "Ocurrió un error inesperado.";
};

const obtenerIconoTipo = (clave?: string | null) => {
  switch ((clave ?? "").toUpperCase()) {
    case "CPU": return <BsCpu size={18} />;
    case "LAP": return <BsLaptop size={18} />;
    case "SV": return <BsServer size={18} />;
    case "WIFI": return <BsWifi size={18} />;
    default: return <BsHddNetwork size={18} />;
  }
};

const obtenerColorEstado = (estado?: string | null): string => {
  const valor = (estado ?? "").toLowerCase();
  if (valor.includes("activo")) return "success";
  if (valor.includes("repar")) return "warning";
  if (valor.includes("almac")) return "info";
  if (valor.includes("prest")) return "primary";
  if (valor.includes("baja")) return "danger";
  if (
  valor.includes("donaci") ||
  valor.includes("destru")
) {
  return "dark";
}
  return "secondary";
};

const InventarioEquipos = () => {
 const [vistaActiva, setVistaActiva] =
  useState<
    "EQUIPOS" |
    "MONITORES" |
    "DISPONIBILIDAD_IPS"
  >("EQUIPOS");
  const [equipos, setEquipos] = useState<DTOEquipoInventario[]>([]);
  const [tiposEquipo, setTiposEquipo] = useState<DTOTipoEquipo[]>([]);
  const [estadosEquipo, setEstadosEquipo] = useState<DTOEstadoEquipo[]>([]);
  // 🌟 NUEVO ESTADO: Almacena el listado de empleados de la base de datos
  const [empleados, setEmpleados] = useState<any[]>([]);
  const [cargando, setCargando] = useState(false);

  const [busqueda, setBusqueda] = useState("");
  // const [filtroOperacion, setFiltroOperacion] = useState<"TODOS" | "ACTIVOS" | "INACTIVOS">("TODOS");

  type FiltroEquipos =
  | "TODOS"
  | "ACTIVOS"
  | "INACTIVOS"
  | "ASIGNADOS"
  | "SIN_ASIGNAR";

const [filtroOperacion, setFiltroOperacion] =
  useState<FiltroEquipos>("TODOS");

  

  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [equipoEditar, setEquipoEditar] = useState<DTOEquipoInventario | null>(null);
  const [idEquipoDetalle, setIdEquipoDetalle] = useState<number | null>(null);
  const [showConfirmarBaja, setShowConfirmarBaja] = useState(false);
  const [equipoBaja, setEquipoBaja] = useState<DTOEquipoInventario | null>(null);
  const [procesandoBaja, setProcesandoBaja] = useState(false);
const [showConfirmarDonacion, setShowConfirmarDonacion] =
  useState(false);

const [equipoDonacion, setEquipoDonacion] =
  useState<DTOEquipoInventario | null>(null);

const [procesandoDonacion, setProcesandoDonacion] =
  useState(false);


  const [showMsg, setShowMsg] = useState(false);
  const [msg, setMsg] = useState("");
  const [header, setHeader] = useState("");
  const [msgColor, setMsgColor] = useState("primary");

  const mostrarMensaje = (encabezado: string, mensaje: string, color: string) => {
    setHeader(encabezado);
    setMsg(mensaje);
    setMsgColor(color);
    setShowMsg(true);
  };

  

  const cargarDatos = async () => {
    setCargando(true);
    try {
      // 🌟 Cambiamos el cuarto método para usar tu servicio maestro de empleados
      const [respuestaEquipos, respuestaTipos, respuestaEstados, respuestaEmpleados] = await Promise.all([
        InventarioService.obtenerEquipos(),
        InventarioService.obtenerTiposEquipo(),
        InventarioService.obtenerEstadosEquipo(),
        ControlContrasenasService.GetEmpleadosMaster(), // 👈 Reutilizamos tu método maestro aquí
      ]);

      setEquipos(respuestaEquipos.data ?? []);
      setTiposEquipo(respuestaTipos.data ?? []);
      setEstadosEquipo(respuestaEstados.data ?? []);
      setEmpleados(respuestaEmpleados.data ?? []); // 👈 Guarda el array maestro en el estado local
    } catch (errorPeticion) {
      mostrarMensaje("Error", obtenerMensajeError(errorPeticion), "danger");
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    void cargarDatos();
  }, []);

  // const equiposFiltrados = useMemo(() => {
  //   return equipos.filter((equipo) => {
  //     const stringActivo = equipo.activo !== null && equipo.activo !== undefined 
  //       ? String(equipo.activo).trim().toLowerCase() 
  //       : "0";
      
  //     const esActivo = stringActivo === "1" || stringActivo === "true";

  //     if (filtroOperacion === "ACTIVOS" && !esActivo) return false;
  //     if (filtroOperacion === "INACTIVOS" && esActivo) return false;

  //     const textoBusqueda = busqueda.trim().toLowerCase();
  //     return (
  //       !textoBusqueda ||
  //       [
  //         equipo.nombreEquipo,
  //         equipo.tipoEquipo,
  //         equipo.descripcionTipo,
  //         equipo.estadoEquipo,
  //         equipo.serviceTagSerial,
  //         equipo.numEmpleadoAsignado,
  //         equipo.nombreEmpleado,
  //         equipo.observaciones,
  //       ]
  //         .filter(Boolean)
  //         .some((valor) => String(valor).toLowerCase().includes(textoBusqueda))
  //     );
  //   });
  // }, [equipos, busqueda, filtroOperacion]);

  const equiposFiltrados = useMemo(() => {
  return equipos.filter((equipo) => {
    const valorActivo =
      equipo.activo !== null &&
      equipo.activo !== undefined
        ? String(equipo.activo)
            .trim()
            .toLowerCase()
        : "0";

    const esActivo =
      valorActivo === "1" ||
      valorActivo === "true";

    const estaAsignado =
      Boolean(
        equipo.numEmpleadoAsignado?.trim()
      ) ||
      Boolean(
        equipo.nombreResponsable?.trim()
      );

    if (
      filtroOperacion === "ACTIVOS" &&
      !esActivo
    ) {
      return false;
    }

    if (
      filtroOperacion === "INACTIVOS" &&
      esActivo
    ) {
      return false;
    }

    if (
      filtroOperacion === "ASIGNADOS" &&
      (!esActivo || !estaAsignado)
    ) {
      return false;
    }

    if (
      filtroOperacion === "SIN_ASIGNAR" &&
      (!esActivo || estaAsignado)
    ) {
      return false;
    }

    const textoBusqueda =
      busqueda.trim().toLowerCase();

    if (!textoBusqueda) return true;

    return [
      equipo.nombreEquipo,
      equipo.tipoEquipo,
      equipo.descripcionTipo,
      equipo.estadoEquipo,
      equipo.serviceTagSerial,
      equipo.numEmpleadoAsignado,
      equipo.nombreEmpleado,
      equipo.nombreResponsable,
      equipo.localidad,
      equipo.observaciones,
    ]
      .filter(Boolean)
      .some((valor) =>
        String(valor)
          .toLowerCase()
          .includes(textoBusqueda)
      );
  });
}, [equipos, busqueda, filtroOperacion]);





  const totalActivos = useMemo(() => {
    return equipos.filter((equipo) => {
      const val = equipo.activo !== null && equipo.activo !== undefined ? String(equipo.activo).trim().toLowerCase() : "0";
      return val === "1" || val === "true";
    }).length;
  }, [equipos]);

  const totalInactivos = useMemo(() => {
    return equipos.length - totalActivos;
  }, [equipos, totalActivos]);

  const totalEquiposAsignados = equipos.filter(
  (equipo) =>
    equipo.activo &&
    (
      Boolean(equipo.numEmpleadoAsignado?.trim()) ||
      Boolean(equipo.nombreResponsable?.trim())
    )
).length;

const totalEquiposSinAsignar = equipos.filter(
  (equipo) =>
    equipo.activo &&
    !equipo.numEmpleadoAsignado?.trim() &&
    !equipo.nombreResponsable?.trim()
).length;

  const abrirNuevoEquipo = () => {
    setEquipoEditar(null);
    setMostrarFormulario(true);
  };

  const abrirEditarEquipo = (equipo: DTOEquipoInventario) => {
    const stringActivo = equipo.activo !== null && equipo.activo !== undefined ? String(equipo.activo).trim() : "0";
    if (stringActivo === "0" || stringActivo === "false") {
      alert("Este equipo está inactivo (de baja). Para editarlo, primero debes usar el botón de reactivación.");
      return;
    }
    setEquipoEditar(equipo);
    setMostrarFormulario(true);
  };

  const ejecutarReactivacion = async (equipo: DTOEquipoInventario) => {
    const nuevoEstadoValido = estadosEquipo.find(e => e.estado.toLowerCase().includes("activo"))?.idEstadoEquipo || 1;
    const confirmar = window.confirm(`¿Deseas reactivar el equipo "${equipo.nombreEquipo}" al inventario operativo?`);
    if (!confirmar) return;

    try {
      await InventarioService.gestionarEquipo({
        accion: "REACTIVAR",
        idEquipo: equipo.idEquipo,
        idTipoEquipo: equipo.idTipoEquipo ?? 1,
        idEstadoEquipo: nuevoEstadoValido,
        nombreEquipo: equipo.nombreEquipo,

      });
      mostrarMensaje("Éxito", "Equipo reactivado y recursos vinculados.", "success");
      await cargarDatos();
    } catch (err) {
      mostrarMensaje("Error", obtenerMensajeError(err), "danger");
    }
  };

  const guardarEquipo = async (dto: DTOGestionarEquipo) => {
    try {
      const respuesta = await InventarioService.gestionarEquipo(dto);
      mostrarMensaje("Éxito", respuesta.data.mensaje, "success");
      setMostrarFormulario(false);
      setEquipoEditar(null);
      await cargarDatos();
    } catch (errorPeticion) {
      mostrarMensaje("Error", obtenerMensajeError(errorPeticion), "danger");
      throw errorPeticion;
    }
  };

  const abrirConfirmacionBaja = (equipo: DTOEquipoInventario) => {
    setEquipoBaja(equipo);
    setShowConfirmarBaja(true);
  };

  const confirmarBajaEquipo = async () => {
    if (!equipoBaja) return;
    setProcesandoBaja(true);
    try {
      const respuesta = await InventarioService.gestionarEquipo({
        accion: "ELIMINAR",
        idEquipo: equipoBaja.idEquipo,
      });
      setShowConfirmarBaja(false);
      setEquipoBaja(null);
      mostrarMensaje("Éxito", respuesta.data.mensaje, "success");
      await cargarDatos();
    } catch (errorPeticion) {
      mostrarMensaje("Error", obtenerMensajeError(errorPeticion), "danger");
    } finally {
      setProcesandoBaja(false);
    }
  };

  const abrirConfirmacionDonacion = (
  equipo: DTOEquipoInventario
) => {
  setEquipoDonacion(equipo);
  setShowConfirmarDonacion(true);
};

const confirmarDonacionEquipo = async () => {
  if (!equipoDonacion) return;

  setProcesandoDonacion(true);

  try {
    const respuesta =
      await InventarioService.gestionarEquipo({
        accion: "DONAR_DESTRUIR",
        idEquipo: equipoDonacion.idEquipo,
      });

    setShowConfirmarDonacion(false);
    setEquipoDonacion(null);

    mostrarMensaje(
      "Éxito",
      respuesta.data.mensaje,
      "success"
    );

    await cargarDatos();
  } catch (errorPeticion) {
    mostrarMensaje(
      "Error",
      obtenerMensajeError(errorPeticion),
      "danger"
    );
  } finally {
    setProcesandoDonacion(false);
  }
};


  const columnas: TableColumn<DTOEquipoInventario>[] = [
    {
      name: "Activo / Identificador",
      minWidth: "240px",
      sortable: true,
      selector: (row) => row.nombreEquipo,
      cell: (row) => (
        <div className="d-flex align-items-center gap-3 py-2">
          <div className="d-flex align-items-center justify-content-center rounded-3 shadow-sm border" style={{ width: 40, height: 42, minWidth: 40, backgroundColor: "#f8fafc", color: "#2563eb" }}>
            {obtenerIconoTipo(row.tipoEquipo)}
          </div>
          <div>
            <div className="fw-bold text-slate-800" style={{ fontSize: "13.5px", color: "#0f172a" }}>{row.nombreEquipo}</div>
            <div className="text-muted" style={{ fontSize: "11px", fontWeight: 500 }}>{row.descripcionTipo ?? row.tipoEquipo ?? "Sin tipo"}</div>
          </div>
        </div>
      ),
    },
    {
      name: "Tipo clave",
      width: "115px",
      sortable: true,
      selector: (row) => row.tipoEquipo ?? "",
      cell: (row) => <Badge bg="light" text="dark" className="border px-2.5 py-2" style={{ fontSize: "11px", fontWeight: 600 }}>{row.tipoEquipo ?? "N/A"}</Badge>,
    },
    {
      name: "Estatus",
      width: "125px",
      sortable: true,
      selector: (row) => row.estadoEquipo ?? "",
      cell: (row) => <Badge bg={obtenerColorEstado(row.estadoEquipo)} className="px-2.5 py-2" style={{ fontSize: "10.5px", fontWeight: 700, letterSpacing: "0.02em" }}>{row.estadoEquipo ?? "Sin estado"}</Badge>,
    },
    {
      name: "Fabricante Serial",
      minWidth: "185px",
      sortable: true,
      selector: (row) => row.serviceTagSerial ?? "",
      cell: (row) => <span className="font-monospace" style={{ fontSize: "12px", color: "#475569", fontWeight: 600 }}>{row.serviceTagSerial ?? "—"}</span>,
    },
    {
      name: "Asignado a",
      minWidth: "260px",
      sortable: true,
      selector: (row) => `${row.numEmpleadoAsignado ?? ""} ${row.nombreEmpleado ?? ""}`,
      cell: (row) => (
        <div style={{ fontSize: "12.5px" }}>
         

          {row.numEmpleadoAsignado ? (
          <div>
            <div className="fw-semibold text-dark">
              {row.nombreEmpleado || "Empleado asignado"}
            </div>

            <div className="small text-muted">
              Empleado #{row.numEmpleadoAsignado}
            </div>
          </div>
        ) : row.nombreResponsable ? (
          <div>
            <div className="fw-semibold text-dark">
              {row.nombreResponsable}
            </div>

            <div className="small text-muted">
              Responsable externo
            </div>
          </div>
        ) : (
          <div>
            <div className="fw-semibold text-muted">
              Sin asignar
            </div>

            <div className="small text-muted">
              No necesita 
            </div>
          </div>
        )}



        </div>
      ),
    },
    {
      name: "Localidad",
      minWidth: "185px",
      sortable: true,
      selector: (row) => row.localidad ?? "",
      cell: (row) => <span className="font-monospace" style={{ fontSize: "12px", color: "#475569", fontWeight: 600 }}>{row.localidad ?? "—"}</span>,
    },
    {
      name: "Alta",
      width: "115px",
      sortable: true,
      selector: (row) => row.fechaAlta,
      cell: (row) => <span style={{ fontSize: "12px", color: "#64748b", fontWeight: 500 }}>{new Date(row.fechaAlta).toLocaleDateString("es-MX")}</span>,
    },

    {
      name: "Acciones",
      width: "200px",
      right: true,
      cell: (row) => {
        const valActivo = row.activo !== null && row.activo !== undefined ? String(row.activo).trim().toLowerCase() : "0";
        const esInactivo = valActivo === "0" || valActivo === "false";

        return (
          <div className="d-flex gap-1">
            <Button size="sm" variant="outline-primary" style={{ border: "1px solid #e2e8f0" }} title="Ver detalle" onClick={() => setIdEquipoDetalle(row.idEquipo)}>
              <BsEye size={13} />
            </Button>
            
            {esInactivo ? (
              <Button size="sm" variant="outline-success" style={{ border: "1px solid #a3e635" }} title="Reactivar activo" onClick={() => void ejecutarReactivacion(row)}>
                <BsArrowCounterclockwise size={13} />
              </Button>
            ) : (
              <>
                <Button size="sm" variant="outline-secondary" style={{ border: "1px solid #e2e8f0" }} title="Editar equipo" onClick={() => abrirEditarEquipo(row)}>
                  <BsPencilSquare size={13} />
                </Button>
                <Button size="sm" variant="outline-danger" style={{ border: "1px solid #e2e8f0" }} title="Dar de baja" onClick={() => abrirConfirmacionBaja(row)}>
                  <BsTrash3 size={13} />
                </Button>

                <Button
  size="sm"
  variant="outline-warning"
  style={{ border: "1px solid #fbbf24" }}
  title="Marcar como donación o destrucción"
  onClick={() => abrirConfirmacionDonacion(row)}
>
  <BsExclamationTriangle size={13} />
</Button>
              </>
            )}
          </div>
        );
      },
    },
  ];

  const estilosTabla = {
    headRow: { style: { backgroundColor: "#f8fafc", borderBottom: "1px solid #e2e8f0", minHeight: "48px" } },
    headCells: { style: { color: "#64748b", fontSize: "11px", fontWeight: 700, textTransform: "uppercase" as const, letterSpacing: ".05em" } },
    rows: {
      style: { minHeight: "64px", fontSize: "13px", borderBottom: "1px solid #f1f5f9" },
      highlightOnHoverStyle: { backgroundColor: "#f8fafc", borderBottomColor: "#cbd5e1", outline: "none", borderLeft: "3px solid #2563eb" },
    },
    pagination: { style: { borderTop: "1px solid #e2e8f0" } },
  };




  const selectorVista = (
  <Card
    className="border-0 shadow-sm mb-3"
    style={{
      borderRadius: "12px",
      border: "1px solid #e2e8f0",
    }}
  >
    <Card.Body className="p-2">
      <div className="d-flex flex-wrap gap-2">
        <Button
          variant={
            vistaActiva === "EQUIPOS"
              ? "primary"
              : "light"
          }
          className="px-4"
          onClick={() => setVistaActiva("EQUIPOS")}
        >
          <BsBoxSeam className="me-2" />
          Equipos
        </Button>

        <Button
          variant={
            vistaActiva === "MONITORES"
              ? "primary"
              : "light"
          }
          className="px-4"
          onClick={() => setVistaActiva("MONITORES")}
        >
          <BsDisplay className="me-2" />
          Monitores
        </Button>

        <Button
  variant={
    vistaActiva === "DISPONIBILIDAD_IPS"
      ? "primary"
      : "light"
  }
  className="px-4"
  onClick={() =>
    setVistaActiva("DISPONIBILIDAD_IPS")
  }
>
  <BsDiagram3 className="me-2" />
  Disponibilidad IPs
</Button>
      </div>
    </Card.Body>
  </Card>
);

if (vistaActiva === "MONITORES") {
  return (
    <div
      className="p-3"
      style={{
        minHeight: "100vh",
        backgroundColor: "#f8fafc",
      }}
    >
      {selectorVista}

      <InventarioMonitores />
    </div>
  );
}

if (vistaActiva === "DISPONIBILIDAD_IPS") {
  return (
    <div
      className="p-3"
      style={{
        minHeight: "100vh",
        backgroundColor: "#f8fafc",
      }}
    >
      {selectorVista}

      <ReporteDisponibilidadIPs />
    </div>
  );
}

  return (
    <div className="p-3" style={{ minHeight: "100vh", backgroundColor: "#f8fafc" }}>
       {selectorVista}

      
      
      {/* BARRA DE ACCIÓN PRINCIPAL */}
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3" style={{ background: "#ffffff", padding: "14px 20px", borderRadius: "12px", border: "1px solid #e2e8f0" }}>
        <div className="d-flex align-items-center gap-3">
          <div className="d-flex align-items-center justify-content-center rounded-3" style={{ width: 42, height: 42, color: "#2563eb", backgroundColor: "#eff6ff", border: "1px solid #dbeafe" }}>
            <BsBoxSeam size={20} />
          </div>
          <div>
            {/* <h4 className="m-0 fw-bold" style={{ color: "#0f172a", fontSize: "16px", letterSpacing: "-0.02em" }}>Módulo de Inventario</h4> */}
            <span className="text-muted" style={{ fontSize: "11px" }}>Control de activos</span>
          </div>
        </div>

        <Button variant="primary" className="px-3" style={{ fontWeight: 600, fontSize: "13px", borderRadius: "8px", background: "#2563eb", border: "none" }} onClick={abrirNuevoEquipo}>
          <BsPlusCircle className="me-2" size={14} /> Registrar nuevo equipo
        </Button>
      </div>

      {/* BLOQUES DE MÉTRICA DE ENTRADA */}
      <Row className="g-3 mb-3">
        <Col md={6} xl={3} >
          <Card className="border-0 shadow-sm h-100" style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}>
            <Card.Body className="p-3">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="text-muted small fw-semibold">Total Equipos Registrados</div>
                  <div className="fw-bold" style={{ fontSize: 26, color: "#0f172a", marginTop: "2px" }}>{equipos.length}</div>
                </div>
                <div style={{ width: 46, height: 46, backgroundColor: "#eff6ff", color: "#2563eb" }} className="d-flex align-items-center justify-content-center rounded-3 border">
                  <BsHddNetwork size={22} />
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} xl={3}  >
          <Card className="border-0 shadow-sm h-100" style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}>
            <Card.Body className="p-3">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="text-muted small fw-semibold">Activos Operando</div>
                  <div className="fw-bold" style={{ fontSize: 26, color: "#16a34a", marginTop: "2px" }}>{totalActivos}</div>
                </div>
                <div style={{ width: 46, height: 46, backgroundColor: "#f0fdf4", color: "#16a34a" }} className="d-flex align-items-center justify-content-center rounded-3 border">
                  <BsCpu size={22} />
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} xl={3}>
  <Card className="border-0 shadow-sm h-100">
    <Card.Body className="p-3">
      <div className="text-muted small fw-semibold">
        Equipos asignados
      </div>

      <div
        className="fw-bold text-primary"
        style={{ fontSize: 26 }}
      >
        {totalEquiposAsignados}
      </div>
    </Card.Body>
  </Card>
</Col>

<Col md={6} xl={3}>
  <Card className="border-0 shadow-sm h-100">
    <Card.Body className="p-3">
      <div className="text-muted small fw-semibold">
        Equipos sin asignar
      </div>

      <div
        className="fw-bold text-warning"
        style={{ fontSize: 26 }}
      >
        {totalEquiposSinAsignar}
      </div>
    </Card.Body>
  </Card>
</Col>
      </Row>

      {/* FILTROS Y DATATABLE */}
      <Card className="border-0 shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
        <Card.Body className="p-0">
          <div className="p-3 bg-white" style={{ borderBottom: "1px solid #e2e8f0" }}>
            <Row className="g-3 align-items-end">
              <Col xs={12} md={8}>
                <Form.Label className="small fw-bold mb-1.5" style={{ color: "#475569", fontSize: "12px" }}>Filtro de búsqueda inteligente</Form.Label>
                <InputGroup className="shadow-sm" style={{ borderRadius: "8px", overflow: "hidden" }}>
                  <InputGroup.Text className="bg-light text-muted border-end-0"><BsSearch size={14} /></InputGroup.Text>
                  <Form.Control
                    placeholder="Filtra al vuelo ingresando: nombre del activo, fabricante, service tag..."
                    value={busqueda}
                    style={{ fontSize: "13px", borderLeft: "none" }}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setBusqueda(e.target.value)}
                  />
                </InputGroup>
              </Col>

              <Col xs={12} md={4}>
                {/* <Form.Label className="small fw-bold mb-1.5" style={{ color: "#475569", fontSize: "12px" }}>Estatus Operativo</Form.Label> */}
                <Form.Label
                              className="small fw-bold mb-1.5"
                              style={{
                                color: "#475569",
                                fontSize: "12px",
                              }}
                            >
                              Filtro de equipos
                            </Form.Label>



                <InputGroup className="shadow-sm" style={{ borderRadius: "8px", overflow: "hidden" }}>
                  <InputGroup.Text className="bg-light text-muted border-end-0"><BsSliders size={14} /></InputGroup.Text>
                  {/* <Form.Select
                    value={filtroOperacion}
                    style={{ fontSize: "13px", cursor: "pointer" }}
                    onChange={(e) => setFiltroOperacion(e.target.value as "TODOS" | "ACTIVOS" | "INACTIVOS")}
                  >
                    <option value="TODOS">Todos los equipos ({equipos.length})</option>
                    <option value="ACTIVOS">Solo Activos ({totalActivos})</option>
                    <option value="INACTIVOS">Solo Inactivos / De baja ({totalInactivos})</option>
                  </Form.Select> */}

                  <Form.Select
  value={filtroOperacion}
  style={{
    fontSize: "13px",
    cursor: "pointer",
  }}
  onChange={(event) =>
    setFiltroOperacion(
      event.target.value as FiltroEquipos
    )
  }
>
  <option value="TODOS">
    Todos los equipos ({equipos.length})
  </option>

  <option value="ACTIVOS">
    Solo activos ({totalActivos})
  </option>

  <option value="INACTIVOS">
    Solo inactivos / de baja ({totalInactivos})
  </option>

  <option value="ASIGNADOS">
    Equipos asignados ({totalEquiposAsignados})
  </option>

  <option value="SIN_ASIGNAR">
    Equipos sin asignar ({totalEquiposSinAsignar})
  </option>
</Form.Select>
                </InputGroup>
              </Col>
            </Row>
          </div>

          <DataTable
            columns={columnas}
            data={equiposFiltrados}
            customStyles={estilosTabla}
            progressPending={cargando}
            progressComponent={
              <div className="py-5 text-center">
                <Spinner animation="border" variant="primary" size="sm" />
                <div className="text-muted mt-2" style={{ fontSize: "12px" }}>Sincronizando base de datos...</div>
              </div>
            }
            pagination
            highlightOnHover
            responsive
          />
        </Card.Body>
      </Card>

      {/* COMPONENTES SECUNDARIOS */}
      <FormularioEquipo
        show={mostrarFormulario}
        equipo={equipoEditar}
        tiposEquipo={tiposEquipo}
        estadosEquipo={estadosEquipo}
        empleados={empleados} // 🌟 PASAMOS LOS EMPLEADOS AQUÍ AL FORMULARIO HIJO
        onCerrar={() => { setMostrarFormulario(false); setEquipoEditar(null); }}
        onGuardar={guardarEquipo}
      />

      <DetalleEquipo show={idEquipoDetalle !== null} idEquipo={idEquipoDetalle} onCerrar={() => setIdEquipoDetalle(null)} />

      {/* MODAL DE BAJA */}
      <Modal show={showConfirmarBaja} onHide={() => { if (!procesandoBaja) { setShowConfirmarBaja(false); setEquipoBaja(null); } }} centered>
        <Modal.Header closeButton className="bg-danger text-white border-0" closeVariant="white">
          <Modal.Title className="fs-6 fw-bold">Confirmación de baja técnica</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-white">
          <div className="text-center py-3">
            <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: 60, height: 60, color: "#dc3545", backgroundColor: "#fee2e2" }}><BsTrash3 size={24} /></div>
            <h5 className="fw-bold">¿Retirar activo del inventario?</h5>
            <p className="fw-bold fs-5" style={{ color: "#dc2626" }}>{equipoBaja?.nombreEquipo}</p>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 bg-light">
          <Button variant="light" disabled={procesandoBaja} onClick={() => { setShowConfirmarBaja(false); setEquipoBaja(null); }}>Cancelar</Button>
          <Button variant="danger" disabled={procesandoBaja} onClick={() => void confirmarBajaEquipo()}>Sí, confirmar baja</Button>
        </Modal.Footer>
      </Modal>


            <Modal
  show={showConfirmarDonacion}
  onHide={() => {
    if (!procesandoDonacion) {
      setShowConfirmarDonacion(false);
      setEquipoDonacion(null);
    }
  }}
  centered
>
  <Modal.Header
    closeButton
    className="bg-warning border-0"
  >
    <Modal.Title className="fs-6 fw-bold">
      Confirmación de donación o destrucción
    </Modal.Title>
  </Modal.Header>

  <Modal.Body className="bg-white">
    <div className="text-center py-3">
      <div
        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
        style={{
          width: 60,
          height: 60,
          color: "#92400e",
          backgroundColor: "#fef3c7",
        }}
      >
        <BsExclamationTriangle size={24} />
      </div>

      <h5 className="fw-bold">
        ¿Marcar este equipo como donado o destruido?
      </h5>

      <p
        className="fw-bold fs-5"
        style={{ color: "#92400e" }}
      >
        {equipoDonacion?.nombreEquipo}
      </p>

      <p className="text-muted mb-0">
        El equipo quedará inactivo y se conservará
        en el histórico.
      </p>
    </div>
  </Modal.Body>

  <Modal.Footer className="border-0 bg-light">
    <Button
      variant="light"
      disabled={procesandoDonacion}
      onClick={() => {
        setShowConfirmarDonacion(false);
        setEquipoDonacion(null);
      }}
    >
      Cancelar
    </Button>

    <Button
      variant="warning"
      disabled={procesandoDonacion}
      onClick={() => void confirmarDonacionEquipo()}
    >
      Sí, marcar como donación/destrucción
    </Button>
  </Modal.Footer>
</Modal>








      <MsgInformativo show={showMsg} header={header} msg={msg} msgColor={msgColor} closeToast={() => setShowMsg(false)} />
    </div>
  );
};

export default InventarioEquipos;















